// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_chat_clear_button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Clear chat`
};

const id_chat_clear_button_label = /** @type {(inputs: {}) => string} */ () => {
	return `Hapus obrolan`
};

const ja_chat_clear_button_label = /** @type {(inputs: {}) => string} */ () => {
	return `クリアチャット`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_clear_button_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_clear_button_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_clear_button_label", locale)
	if (locale === "en") return en_chat_clear_button_label(inputs)
	if (locale === "id") return id_chat_clear_button_label(inputs)
	return ja_chat_clear_button_label(inputs)
};
export { chat_clear_button_label as "chat.clear_button_label" }